import { Inject, Injectable } from '@angular/core';
import { PSAcuerdoBasicoModel } from '../models/ps-acuerdo-basico-model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PsAcuerdoBasicoService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getAllById(idPS: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_AcuerdoBasico/${idPS}`);
  }

  post(item: PSAcuerdoBasicoModel[]) {
    return this._http.post<PSAcuerdoBasicoModel[]>(`${ this.myAppUrl }api/PS_AcuerdoBasico`, item);
  }

}
